// extracted by mini-css-extract-plugin
module.exports = {"marque":"client_marque__P4M_P","marqueTrack":"client_marqueTrack__F_IbK","marquee":"client_marquee__kQ0LN","marqueInner":"client_marqueInner__EE8_f"};